/** The brokers a worker or an order can run on (shared by server and client). */
export const BROKER_NAMES = ['ibkr', 'robinhood'] as const
export type BrokerName = (typeof BROKER_NAMES)[number]
export const BROKER_LABEL: Record<BrokerName, string> = { ibkr: 'IBKR', robinhood: 'Robinhood' }
/** What the broker can and cannot do itself — shown on cards so the plan reads true. */
export const BROKER_NOTE: Record<BrokerName, string> = {
  ibkr: 'Targets and stops rest at IBKR as one bracket per lot.',
  robinhood:
    'Robinhood has no linked target + stop: each lot’s STOP rests at Robinhood, its target and every automatic rule are run by this server on live quotes (a target is swapped in for the stop when the price reaches it). Stops work in regular hours only.',
}
